require('./redeemPromoController');

"use strict";

angular.module('app.redeemPromo', ['app.redeemPromo.redeemPromoController'])
  .config([
    '$stateProvider', 'PRODUCT',
    function ($stateProvider, product) {
      
      let redeemPromoTemplate = 'components/promo/redeemPromoView.html';

      $stateProvider.state('app.redeemPromo', {
        url: '/redeem-promo',
        templateUrl: redeemPromoTemplate,
        controller: 'app.redeemPromo.redeemPromoController',
        title: 'Redeem Promotion Code',
        noSidebar: false,
        noTitleBar: false
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/promo/redeemPromo.js